import type { Filter } from 'components/filters/useStreamFilters'

type MentionUser = {
    id?: string | number | null
    name?: string | null
}

export function buildUserStreamMentionDelta(filter: Filter, user: MentionUser | null | undefined) {
    const filterUserId = filter?.user
    const userName = user?.name

    if (!filterUserId || !user?.id || !userName || String(user.id) !== String(filterUserId)) {
        return null
    }

    return {
        ops: [
            {
                insert: {
                    mention: {
                        id: user.id,
                        value: userName,
                        content: userName,
                        type: 'user',
                        denotationChar: '@',
                        link: `/users/${userName}`,
                    },
                },
            },
            { insert: ' ' },
        ],
    }
}
